PJQ.views.settings.CommitmentSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'commitments'),
        model: null,
        customFields: null
    },
    events: {
        'click .btn-manage-signature': 'manageSignature',
        'keydown .input-percent': 'numbersOnly',
        'change .input-percent': 'formatPercent',
    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            useDecimalPercentFields: true,
            watchElements: [
                'input'
            ],
            afterChange: ($el, attribute) => {
                if (attribute === 'disableSubcontracts' || attribute === 'disablePO') {
                    this.render();
                }

                this.onChange();
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-default-accounting-method'),
            isIntChoices: true,
            isMultiple: false,
            defaultValue: this.model.get('defaultAccountingMethod') != null ? this.model.get('defaultAccountingMethod') : PJQ.constants.budget.accountingMethod.UNIT_QUANTITY,
            onChange: _.bind(function (value) {
                this.model.set('defaultAccountingMethod', value);
                this.onChange();
            }, this)
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format-po'),
            commitmentType: PJQ.constants.commitments.commitmentType.PURCHASE_ORDER,
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('purchaseOrderNumberFormat', value);
                this.onChange();
            }
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format-subcontract'),
            commitmentType: PJQ.constants.commitments.commitmentType.SUBCONTRACT,
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('subcontractNumberFormat', value);
                this.onChange();
            }
        });

        new PJQ.views.settings.SignatureEditInput({
            el: this.$('.manage-signature-input'),
            signature: this.model.get('defaultSignature'),
            headerSubText: "Manage your company's default signature for Commitments",
            onSave: _.bind(function (signature) {
                this.model.set('defaultSignature', signature);
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    formatPercent: function (e) {
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatPercent($(e.currentTarget).val()));
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});

PJQ.views.settings.CommitmentChangeOrderSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'commitment-change-orders'),
        model: null,
        customFields: null
    },
    events: {},
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            afterChange: ($el, attribute) => {
                this.onChange();
            }
        });

        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.views.settings.SignatureEditInput({
            el: this.$('.manage-signature-input'),
            signature: this.model.get('defaultSignature'),
            headerSubText: "Manage your company's default signature for Commitment Change Orders",
            onSave: _.bind(function (signature) {
                this.model.set('defaultSignature', signature);
                this.onChange();
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});